import { render, staticRenderFns } from "./FragmentBox.vue?vue&type=template&id=4a10509a&"
import script from "./FragmentBox.vue?vue&type=script&lang=ts&"
export * from "./FragmentBox.vue?vue&type=script&lang=ts&"
import style0 from "./FragmentBox.vue?vue&type=style&index=0&id=4a10509a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports